import { getNormalizedCartItems } from "../../utils";

const viewCart = () => (dispatch, getState) => {
  const items = getNormalizedCartItems(getState());
  window.GTM.pushViewCart({ items });
};

export default viewCart;
